import { CLOSE_MASK, OPEN_MASK, SET_SSO } from '../../constant';

const setSsoStatus = (params) => ({
  type: SET_SSO,
  payload: params,
});

const openMask = (params) => ({
  type: OPEN_MASK,
});

const closeMask = (params) => ({
  type: CLOSE_MASK,
});

export { setSsoStatus, openMask, closeMask };
